import { render } from "./EventEditor.vue?vue&type=template&id=588b7cc3"
import script from "./EventEditor.vue?vue&type=script&lang=js"
export * from "./EventEditor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__